import { ComponentType } from 'react';
import { Subject } from 'rxjs';
import { modalSubject } from './modal-container';
import { ModalOptions, ModalRef, ExtractModalData } from './modal.type';

let unique = 1;

export function openModal<T = ComponentType<any>>(Content: T, options?: ModalOptions<ExtractModalData<T>>) {
  const modalId = unique++;
  const modalSbj: Subject<any>[] = [];
  const modalRef: ModalRef = {
    close: (data: any) => {
      modalSbj.forEach((sj) => {
        sj.next(data);
      });

      modalSubject.next(modalSubject.getValue().filter((modal) => modal.modalId !== modalId));

      try {
        document.body.classList.remove('h-overflow-hidden');
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
    afterClosed: () => {
      const sj = new Subject();

      modalSbj.push(sj);

      return sj;
    },
    cleanData: (data: any) => {
      modalSbj.forEach((sj) => {
        sj.next(data);
      });

      modalSubject.next([...modalList, { modalId, content: Content, options: modalOpts, modalRef }]);
    },
  };

  const modalList = modalSubject.getValue();
  const modalOpts: ModalOptions = options || {};

  try {
    document.body.classList.add('h-overflow-hidden');
    // eslint-disable-next-line no-empty
  } catch (err) {}

  modalSubject.next([...modalList, { modalId, content: Content, options: modalOpts, modalRef }]);

  return modalRef;
}
